import React from 'react'
import {Button, Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers'

interface SuccessDialogProps {
  show: boolean
  onHide: () => void
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({show, onHide}) => {
  return (
    <Modal show={show} onHide={onHide} centered={true}>
      <Modal.Body>
        <div className='d-flex flex-column gap-6 align-items-center'>
          <img src='/media/congratulations.gif' alt='congratulations' className='w-25' />
          <div>
            <h1 className='text-center'>Congratulations</h1>
            <span className='text-center text-muted'>You have upgraded your plan</span>
          </div>
          <Button
            variant='primary'
            className='border border-primary w-100 rounded-pill'
            onClick={onHide}
          >
            Done
            <KTSVG
              path='/media/icons/duotune/general/Arrow - Right.svg'
              className='svg-icon-2 px-2'
            />{' '}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SuccessDialog
